export default function PropertyTypesSection() {
  const propertyTypes = [
    {
      image: 'https://public.readdy.ai/ai/img_res/a60bca7184fa83764146f3aba54e0d87.jpg',
      title: 'Single-Family Houses',
      features: [
        'Private yard and outdoor space',
        '2-4 bedrooms available',
        'Garage or covered parking',
        'Pet-friendly options',
        'Quiet residential neighborhoods'
      ]
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20duplex%20building%20exterior%20with%20two%20units%2C%20contemporary%20residential%20design%2C%20clean%20architecture%2C%20well-kept%20property%2C%20professional%20real%20estate%20photo%2C%20bright%20natural%20lighting%2C%20attractive%20neighborhood&width=800&height=600&seq=duplex-rental-1&orientation=landscape',
      title: 'Duplexes',
      features: [
        'Affordable housing option',
        'Private entrance for each unit',
        'Shared or individual yards',
        '1-3 bedrooms per unit',
        'Great for small families'
      ]
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20building%20exterior%20with%20multiple%20units%2C%20contemporary%20architecture%2C%20well-maintained%20complex%2C%20professional%20property%20photography%2C%20inviting%20entrance%20area%2C%20urban%20residential%20setting%20with%20landscaping&width=800&height=600&seq=apartment-rental-1&orientation=landscape',
      title: 'Apartments',
      features: [
        'Low-maintenance living',
        'Community amenities',
        'Studio to 2-bedroom layouts',
        'Convenient locations',
        'On-site management'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Choose Your Ideal Living Space
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            From cozy apartments to spacious family homes, we offer a variety of rental options to match your lifestyle and budget.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {propertyTypes.map((type, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-300">
              <div className="w-full h-64">
                <img
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{type.title}</h3>
                <ul className="space-y-3">
                  {type.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-lg mt-0.5 mr-3"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
